import { useAPIGetPraktikKinerjaPelaksanaanSummary } from 'api/kinerja/penilik-pegawai/pelaksanaan'
import { usePenilikStatus } from './useSummary'

import type { QueryStatus } from 'react-query'
import type { PelaksanaanPraktikKinerjaSummary } from 'types/kinerja-penilik-pegawai'

type PelaksanaanPraktikKinerjaSummaryResponse = {
  pelaksanaanPraktikKinerjaSummaryFetchStatus: QueryStatus
  pelaksanaanPraktikKinerjaSummary: PelaksanaanPraktikKinerjaSummary
}
export const usePelaksanaanPraktikKinerjaSummary = (
  providedSkpId?: string
): PelaksanaanPraktikKinerjaSummaryResponse => {
  const { summary } = usePenilikStatus({
    disabled: !!providedSkpId,
  })

  const {
    data: pelaksanaanPraktikKinerjaSummary,
    status: pelaksanaanPraktikKinerjaSummaryFetchStatus,
  } = useAPIGetPraktikKinerjaPelaksanaanSummary({
    skpId: providedSkpId || summary?.skpId,
    opts: {
      enabled: Boolean(providedSkpId || summary?.skpId),
    },
  })

  return {
    pelaksanaanPraktikKinerjaSummaryFetchStatus,
    pelaksanaanPraktikKinerjaSummary,
  }
}
